(() => {
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.site-header details[open]').forEach(item => item.removeAttribute('open'));
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.site-header details[open]').forEach(item => {
      if (!item.contains(event.target)) item.removeAttribute('open');
    });
  });
  document.querySelectorAll('[data-product-slider]').forEach(slider => {
    let paused = false;
    slider.addEventListener('mouseenter', () => { paused = true; });
    slider.addEventListener('mouseleave', () => { paused = false; });
    slider.addEventListener('focusin', () => { paused = true; });
    slider.addEventListener('focusout', () => { paused = false; });
    slider.addEventListener('touchstart', () => { paused = true; }, {passive:true});
    slider.addEventListener('touchend', () => { paused = false; }, {passive:true});
    slider.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      slider.scrollBy({left:event.key === 'ArrowRight' ? 177 : -177, behavior:'smooth'});
    });
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const timer = setInterval(() => {
      if (!slider.isConnected) { clearInterval(timer); return; }
      if (paused || document.hidden || slider.scrollWidth <= slider.clientWidth) return;
      slider.scrollTo({left:slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 2 ? 0 : slider.scrollLeft + 177, behavior:'smooth'});
    }, 4000);
  });
  document.querySelectorAll('[data-product-variants]').forEach(data => {
    const form = data.previousElementSibling;
    if (!form) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch (error) { return; }
    const selects = [...form.querySelectorAll('select[name^="options["]')];
    const idInput = form.querySelector('[data-product-variant-id]');
    const submit = form.querySelector('[type="submit"]');
    if (!selects.length || !idInput) return;
    const syncVariant = () => {
      const values = selects.map(select => select.value);
      const variant = variants.find(item => item.options.every((value, index) => value === values[index]));
      if (!variant) { if (submit) submit.disabled = true; return; }
      idInput.value = variant.id;
      if (submit) submit.disabled = !variant.available;
    };
    selects.forEach(select => select.addEventListener('change', syncVariant));
    syncVariant();
  });
  document.querySelectorAll('[data-mra-video]').forEach(card => {
    const button = card.querySelector('.mra-video-card__poster');
    if (!button) return;
    button.addEventListener('click', () => {
      const id = card.dataset.mraVideo;
      if (!id) return;
      const frame = document.createElement('iframe');
      frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0`;
      frame.title = 'Mr. A video';
      frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      frame.allowFullscreen = true;
      button.replaceWith(frame);
    });
  });
})();
